import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { GripVertical, X } from "lucide-react";
import { Button } from "./ui/button";
import AddressAutocomplete from "./AddressAutocomplete";

const SortableStopItem = ({ id, index, stop, onUpdate, onRemove, onSelect }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.4 : 1,
    zIndex: isDragging ? 50 : "auto",
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={`flex items-center gap-2 ${isDragging ? "ring-2 ring-primary/30 rounded-lg bg-background" : ""}`}
      data-testid={`sortable-stop-${index}`}
    >
      {/* Drag handle */}
      <button
        type="button"
        className="cursor-grab active:cursor-grabbing text-muted-foreground/40 hover:text-muted-foreground/70 transition-colors touch-none flex-shrink-0"
        {...attributes}
        {...listeners}
        data-testid={`drag-handle-${index}`}
      >
        <GripVertical className="h-4 w-4" />
      </button>

      <span className="w-5 h-5 rounded-full bg-yellow-500/20 flex items-center justify-center text-xs text-yellow-500 flex-shrink-0">
        {index + 1}
      </span>

      <div className="flex-1">
        <AddressAutocomplete
          value={stop}
          onChange={(value) => onUpdate(index, value)}
          onSuggestionSelect={(place) => onSelect(index, place.description || place)}
          placeholder={`Stop ${index + 1} address`}
          data-testid={`stop-${index}-input`}
        />
      </div>

      <Button
        type="button"
        variant="ghost"
        size="icon"
        onClick={() => onRemove(index)}
        className="text-red-500 hover:text-red-400 hover:bg-red-500/10 h-8 w-8 flex-shrink-0"
        data-testid={`remove-stop-${index}`}
      >
        <X className="h-4 w-4" />
      </Button>
    </div>
  );
};

export default SortableStopItem;
